import { Box } from 'components/box';
import CreateAccount from 'components/customer/create-account';
import Login from 'components/customer/login';
import RequestPasswordReset from 'components/customer/request-password-reset';
import { useEffect, useState } from 'react';

enum FormStateEnum {
  Login = 'login',
  CreateAccount = 'create-account',
  ForgotPassword = 'forgot-password',
}

const CustomerAuthorization = ({
  headerText = 'Log in',
  showCreateAccountBtn = false,
  showFirstTimeCustomersMessage = false,
  setGuestCheckoutActive,
}: {
  headerText?: string;
  showCreateAccountBtn?: boolean;
  showFirstTimeCustomersMessage?: boolean;
  setGuestCheckoutActive?: () => void;
}) => {
  const [activeForm, setActiveForm] = useState<FormStateEnum>(
    FormStateEnum.Login
  );

  useEffect(() => {
    window.history.pushState({ form: FormStateEnum.Login }, '', '');

    const handlePopState = (e: PopStateEvent) => {
      switch (e.state?.form) {
        case FormStateEnum.Login:
        case FormStateEnum.CreateAccount:
        case FormStateEnum.ForgotPassword:
          setActiveForm(e.state.form);
          break;
        default:
          setActiveForm(FormStateEnum.Login);
      }
    };

    window.addEventListener('popstate', handlePopState);

    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  const changeForm = (form: FormStateEnum) => {
    setActiveForm(form);
    window.history.pushState({ form }, '', '');
  };

  return (
    <Box width={['100%', null, '45%']} m="0 auto">
      {activeForm === FormStateEnum.Login && (
        <Login
          headerText={headerText}
          showCreateAccountBtn={showCreateAccountBtn}
          showFirstTimeCustomersMessage={showFirstTimeCustomersMessage}
          createBtnOnClick={() => changeForm(FormStateEnum.CreateAccount)}
          forgotPasswordOnClick={() => changeForm(FormStateEnum.ForgotPassword)}
          guestCheckoutOnClick={setGuestCheckoutActive}
        />
      )}
      {activeForm === FormStateEnum.ForgotPassword && (
        <RequestPasswordReset
          showLoginBtn
          loginBtnOnClick={() => changeForm(FormStateEnum.Login)}
        />
      )}
      {activeForm === FormStateEnum.CreateAccount && (
        <CreateAccount
          showLoginBtn
          loginBtnOnClick={() => changeForm(FormStateEnum.Login)}
        />
      )}
    </Box>
  );
};

export default CustomerAuthorization;
